// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM13 11V6H11V11H13ZM13.0039 12H11V14.0039H13.0039V12Z"}}]};

const ChatErrorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-error-filled',
    ref,
    icon: element,
  },
));

ChatErrorFilledIcon.displayName = 'ChatErrorFilledIcon';

export default ChatErrorFilledIcon;
